<template>
    <div style="height: 100%">
        <div :style="'font-size:'+fontSize1+'px'" class="noticeAlert">
          <i></i>
          <p>该链接由{{detail.user_name}}分享，链接将在{{detail.expire_at}}过期！</p>
        </div>
        <div v-show="isPhone && detail.platform_key != 'b_plus' && detail.platform_key != 'dy'" class="phone">
            <div :style="'font-size:'+fontSize+'px'" class="phone-container">
                <div class="phone">
                  <iframe style="width: 100%;height: 100%" :src="info.preview_mobile_url" frameborder="0" allowfullscreen></iframe>
                    <!-- <img class="topLine" src="../../common/previewBox/assets/phoneTop.png" alt=""> -->
                    <!-- <div class="phoneScroll">
                    <video v-show="detail.video_url" :src="detail.video_url" controls controlslist="nodownload"></video>
                    <div class="title">
                        <p :style="'line-height:' + 0.25 * fontSize + 'px'">{{detail.title}}</p>
                        <div>
                        <p :style="'line-height:' + 0.16 * fontSize + 'px'">{{detail.platform_title}}</p>
                        <p :style="'line-height:' + 0.16 * fontSize + 'px'">{{detail.raw_update_time}}</p>
                        </div>
                    </div>
                    <div class="content">
                        <div v-show="detail.type == 5" :style="'line-height:' + 0.24 * fontSize + 'px'" class="article">
                            {{detail.info}}
                        </div>
                        <div v-show="detail.type == 6" :style="'line-height:' + 0.24 * fontSize + 'px'" v-html="detail.content" class="article">
                        </div>
                        <div class="arrowLine">
                        <p></p>
                        <img src="../../common/previewBox/assets/angle.png" alt="">
                        <p></p>
                        </div>

                        <div v-show="detail.has_copyright == 1" :style="'line-height:' + 0.24 * fontSize + 'px'" class="notice">
                        <i>版权申明：</i>本文系看看新闻Knews独家稿件，未经授权，不得转载。
                        </div>
                    </div>

                    <img class="shareIcon" src="../../common/previewBox/assets/shareIcon.png" alt="">
                    </div> -->
                    <div v-show="detail.platform_key != 'five_star_sports_cms'" class="switch-container">
                        <div :class="{btn: true, un: !showPhone}">
                            <img src="../../common/previewBox/assets/kankanIcon.png" alt="">
                            <p>移动端</p>
                        </div>
                        <div @click="toast" :class="{btn: true, un: showPhone}">
                            <img src="../../common/previewBox/assets/kankanIcon.png" alt="">
                            <p>PC端</p>
                        </div>
                    </div>
                    <!-- <img class="bottomLine" src="../../common/previewBox/assets/bottomIcon.png" alt=""> -->
                </div>
            </div>
        </div>
        <div v-show="isPhone && detail.platform_key == 'b_plus'" class="phone">
          <div :style="'height: 100vh;font-size:'+fontSize+'px'" class="phone-container">
            <div class="phone black">
              <div class="phoneTop">
                <i class="back"></i>
                <i class="search"></i>
              </div>
              <div class="threeBtn">
                <i class="logo"></i>
                <i class="zan"></i>
                <i class="share"></i>
              </div>
              <div class="info">
                <p :style="'line-height:'+0.22*fontSize+'px'" class="col">@{{detail.platform_title}}</p>
                <p :style="'line-height:'+0.18*fontSize+'px'">{{detail.title}}</p>
              </div>
              <video @click="playVideo" ref="bVideo" :poster="detail.cover" :src="detail.video_url" controlslist="nodownload"></video>
              <div class="progress">
                <p :style="'width:'+num+'%'" class="line"></p>
              </div>
              <!-- <div class="phoneScroll">
                  <video :src="detail.video_url" controls controlslist="nodownload"></video>
              </div> -->
            </div>
          </div> 
        </div>

        <div v-show="isPhone && detail.platform_key == 'dy'" class="phone">
          <div :style="'height: 100vh;font-size:'+fontSize+'px'" class="dy-container">
            <div class="top"></div>
            <div class="message">
              <p class="name">@{{detail.account_name}}</p>
              <div class="content">
                <span :class="{word: true, on: toggleShow}" v-html="detail.info"></span>
                <span @click="toggleShow = !toggleShow" v-if="detail.info && detail.info.length > 100" class="toggle">{{toggleShow ? '展开' : '折叠'}}</span>
              </div>
              <p class="from">
                <img src="../../assets/img/dy/dyIcon.png" alt="">
                <span>@{{detail.account_name}}创作的原声</span>
              </p>
            </div>
            <video @click="playVideo" ref="cVideo" :poster="detail.cover" :src="detail.video_url"></video>
            <!-- <div class="progress">
              <p :style="'width:'+num+'%'" class="line"></p>
            </div> -->
            <div class="btn">
              <div class="avatar">
                <img :src="detail.logo" alt="">
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/zan.png" alt="">
                <p>2548</p>
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/comment.png" alt="">
                <p>211</p>
              </div>
              <div class="icon">
                <img src="../../assets/img/dy/share.png" alt="">
                <p>1141</p>
              </div>
              <div class="disk">
                <img class="disk1" src="../../assets/img/dy/disk.png" alt="">
                <img class="sound" src="../../assets/img/dy/music.png" alt="">
              </div>
            </div>
            <div class="bottom"></div>
          </div> 
        </div>
    </div>
</template>

<script>
    import { apis } from "@common/config";
    import common from "@common/common";
    export default {
        data() {
            return {
                toggleShow: true,
                isPlay: false,
                idstring: '',
                type: '',
                isPhone: false,
                showPhone: true,
                fontSize: 100,
                fontSize1: 100,
                detail: {},
                num: 0,
                info: {
                  preview_mobile_url: '',
                  preview_pc_url: ''
                }
            }
        },
        methods: {
            getPreview(id) {
              let info = {
                id: id
              }

              common.myFetch(apis.previewurl, info).then(r => {
                if (r) {
                  console.log(r)
                  this.info = r
                }
              });
            },
            playVideo() {
              // console.log(123)
              if(!this.isPlay){
                if(this.detail.platform_key == "b_plus"){
                  this.$refs.bVideo.play()
                }else if(this.detail.platform_key == "dy"){
                  this.$refs.cVideo.play()
                }
              }else{
                if(this.detail.platform_key == "b_plus"){
                  this.$refs.bVideo.pause()
                }else if(this.detail.platform_key == "dy"){
                  this.$refs.cVideo.pause()
                }
              }
              this.isPlay = !this.isPlay
            },
            getList() {
              let info = {
                  idstring: this.idstring
              }

              common
              .myFetch(apis.newMediaPlatformShareDetail, {method: 'post', needLogin: false, data: info})
              .then(r => {
                  if (r) {
                      console.log(r)
                      r.detail.platformType = r.detail.platform_key
                      r.detail.noClose = true
                      r.detail.newPreview = true
                      this.detail = r.detail
                      
                      if(!this.isPhone){
                          if(r.detail.platformType == 'new_media_knews' || r.detail.platformType == 'five_star_sports_cms'){
                            this.$PreviewKnews(this.detail.id)
                          }else if(r.detail.platformType == 'bilibili'){
                            this.$PreviewBili(this.detail.id)
                          }else{
                            this.$PreviewBox(this.detail)
                          }
                      }else{
                        if(r.detail.platformType == 'new_media_knews' || r.detail.platformType == 'five_star_sports_cms'){
                          this.getPreview(r.detail.id)
                        }
                      }
                  }
              });
            },
            toast() {
                this.$toast('PC端请电脑上查看')
            },
            recalc() {
                var clientWidth = document.documentElement.clientWidth;

                if (!clientWidth) {

                    return;
                }

                var p = 100 * (clientWidth / 375);

                document.documentElement.style.fontSize = p+'px'

                this.fontSize = p
            },
            recalc1() {
                var clientWidth = document.documentElement.clientWidth;

                if (!clientWidth) {

                    return;
                }

                if(this.isPhone){
                  var p = 100 * (clientWidth / 375);
                }else{
                  var p = 100 * (clientWidth / 1920);
                }

                this.fontSize1 = p
            }
        },
        mounted() {
            if(this.isPhone){
                this.recalc()
                if(this.detail.platform_key == "b_plus"){
                  this.$refs.bVideo.addEventListener('ended',() => {
                    this.isPlay = false;
                  })
                  this.$refs.bVideo.addEventListener('timeupdate',() => {
                    // console.log(this.$refs.bVideo.currentTime)
                    let num = this.$refs.bVideo.currentTime / this.$refs.bVideo.duration
                    num = num*100
                    this.num = num;
                  })
                  this.$refs.bVideo.oncontextmenu = function(event) {
                    return false
                  }
                }else if(this.detail.platform_key == "dy"){
                  this.$refs.cVideo.addEventListener('ended',() => {
                    this.isPlay = false;
                  })
                  this.$refs.cVideo.addEventListener('timeupdate',() => {
                    // console.log(this.$refs.bVideo.currentTime)
                    let num = this.$refs.cVideo.currentTime / this.$refs.cVideo.duration
                    num = num*100
                    this.num = num;
                  })
                  this.$refs.cVideo.oncontextmenu = function(event) {
                    return false
                  }
                }
            }

            this.recalc1()

            window.addEventListener('resize', () => {
              this.recalc1()
            })
        },
        created() {
            this.idstring = this.$route.params.idstring
            this.type = this.$route.params.type
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                this.isPhone = true
            } else {
                this.isPhone = false
            }
            this.getList()
        }
    }
</script>

<style lang="less" scoped>
    .noticeAlert {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 0.4em;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      z-index: 999999999999;
      background: #FFFAEB;

      i {
        display: block;
        width: 0.14em;
        height: 0.14em;
        background: url('../../assets/img/newMediaShare/notice.png') no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        margin-right: 0.06em;
      }

      p {
        font-size: 0.12em;
        font-weight: 500;
        color: #775A04;
      }
    }
    .switch-container {
      position: fixed;
      bottom: 0;
      left: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0.99em;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 0%, rgba(0, 0, 0, 0.5) 100%);

      .btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 1.3em;
        height: 0.4em;
        background: #FFFFFF;
        border-radius: 0.2em;
        user-select: none;
        cursor: pointer;

        &.un {
          opacity: 0.5;
        }

        img {
          width: 0.21em;
          height: 0.25em;
          margin-right: 0.08em;
        }

        p {
          font-size: 14px;
          line-height: 44px;
          color: #323B4B;
          font-weight: bold;
        }

        &:nth-of-type(2) {
          margin-left: 0.25em;
        }
      }
    }
    .phone-container {
      position: relative;
      margin-top: 0.4em;

      .close {
        position: absolute;
        top: -0.2em;
        right: -1.5rem;
        width: 0.31em;
        height: 0.31em;
        user-select: none;
        cursor: pointer;
      }

      .phone {
        position: relative;
        width: 3.75em;
        height: 8.12em;
        background: #FFFFFF;
        // border-radius: 0.36em;
        overflow: hidden;
        // padding: 0.44em 0 0.83em;
        box-sizing: border-box;

        &.black {
          position: relative;
          background: #000;
          border-radius: 0.35em;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;

          video {
            width: 100%;
            height: auto;
            max-width: 100%;
          }

          .info {
            position: absolute;
            bottom: 0.53em;
            left: 0;
            width: 90%;
            padding: 0 0.15em;
            box-sizing: border-box;
            z-index: 999;

            .col {
              font-size: 0.16em;
              // line-height: 0.22em;
              color: #FFFFFF;
              font-weight: bold;
            }

            p {
              font-size: 0.13em;
              // line-height: 0.18em;
              color: #FFFFFF;
              word-break: break-all;
            }
          }

          .phoneTop {
            position: absolute;
            top: 0.54em;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0 0.09em;
            box-sizing: border-box;
            z-index: 999;

            i {
              display: block;
              width: 0.24em;
              height: 0.24em;

              &.back {
                background: url('../../assets/img/newMediaShare/back.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }

              &.search {
                background: url('../../assets/img/newMediaShare/search.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
              }
            }
          }

          .threeBtn {
            position: absolute;
            bottom: 0.78em;
            right: 0.19em;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 999;

            .logo {
              display: block;
              width: 0.48em;
              height: 0.48em;
              background: url('../../assets/img/newMediaShare/bMain.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }

            .zan {
              display: block;
              width: 0.39em;
              height: 0.39em;
              background: url('../../assets/img/newMediaShare/zan.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
              margin: 0.31em 0 0.37em;
            }

            .share {
              display: block;
              width: 0.39em;
              height: 0.39em;
              background: url('../../assets/img/newMediaShare/share.png') no-repeat;
              background-size: 100% 100%;
              background-position: center center;
            }
          }
        }

        .phoneScroll {
          height: 100%;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 0px;
          }
          &::-webkit-scrollbar-thumb {
            background: rgba(#dcdcdc, 0.3);
            border-radius: 0px;
          }

          img {
            max-width: 100% !important;
          }
        }

        .topLine {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 0.44em;
        }
        .bottomLine {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.83em;
        }

        video {
          width: 100%;
          height: 2.11em;
        }

        .title {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          min-height: 0.96em;
          padding: 0.15em 0.15em 0.1em;
          border-bottom: 2px solid #EEE;
          box-sizing: border-box;

          &>p {
            font-size: 0.18em;
            // line-height: 0.25em;
            color: #323B4B;      
            font-weight: bold;
          }

          div {
            display: flex;
            flex-direction: column;

            p {
              font-size: 0.12em;
              // line-height: 0.16em;
              color: #829191;

              &:nth-of-type(2) {
                margin-top: 0.03em;
              }
            }
          }
        }

        .content {
          padding: 0.1em 0.15em 0px;
          box-sizing: border-box;

          .article {
            font-size: 0.15em;
            // line-height: 0.24em;
            color: #323B4B;
          }

          .arrowLine {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 0.21em;

            p {
              width: 1.65em;
              height: 1px;
              background: #EEEEEE;
            }

            img {
              width: 0.12em;
              height: 0.1em;
              margin: 0 1px;
            }
          }
        }

        .notice {
          font-size: 0.15em;
          // line-height: 0.24em;
          color: #323B4B;
          margin-top: 2px;
          font-weight: 500;

          i {
            color: #E61939;
          }
        }

        .shareIcon {
          width: 100%;
          height: 0.78em;
          margin-top: 0.08em;
        }
      }

      .progress {
        position: fixed;
        left: 0;
        bottom: 0.38em;
        width: 100%;
        height: 2px;
        background: #666;

        .line {
          position: absolute;
          top: 0;
          left: 0;
          height: 2px;
          background: #FFF;
        }
      }
    }

    .dy-container {
      display: flex;
      justify-content: center;
      align-items: center;
      max-height: 100%;
      max-width: 100%;
      overflow: hidden;
      background: #000;

      .progress {
        position: fixed;
        left: 0;
        bottom: 0.38em;
        width: 100%;
        height: 2px;
        background: #666;

        .line {
          position: absolute;
          top: 0;
          left: 0;
          height: 2px;
          background: #FFF;
        }
      }
      .top {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 0.88em;
        background: url('../../assets/img/dy/top.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }

      video {
        width: 100%;
        height: auto;
        max-height: calc(100vh - 1.68em);
      }

      .message {
        width: 2.65em;
        position: absolute;
        left: 0.12em;
        bottom: 0.93em;
        display: flex;
        flex-direction: column;
        color: #FFF;
        
        .name {
          font-size: 0.16em;
          font-weight: bold;
          margin-bottom: 0.08em;
        }

        .content {
          font-size: 0.13em;
          margin-bottom: 0.08em;

          .word {
            &.on {
              word-break: break-all;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }

        .from {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 0.13em;
            height: 0.13em;
            margin-right: 0.04em;
          }

          span {
            font-size: 0.14em;
          }
        }
      }

      .btn {
        position: absolute;
        right: 0;
        bottom: 0.92em;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 0.51em;

        .avatar {
          display: flex;
          width: 0.51em;
          height: 0.51em;
          border-radius: 50%;
          overflow: hidden;
          margin-bottom: 0.28em;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }

        .icon {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 0.2em;

          img {
            width: 0.39em;
            height: 0.39em;
            margin-bottom: 0.04em;
          }

          p {
            font-size: 0.13em;
            line-height: 0.15em;
            font-weight: bold;
            color: #FFF;
          }
        }

        .disk {
          position: relative;
          margin-top: -0.3em;

          .disk1 {
            width: 0.46em;
            height: 0.46em;
          }

          .sound {
            position: absolute;
            top: 0.6em;
            left: -0.41em;
            width: 0.61em;
            height: 0.66em;
          }
        }
      }

      .bottom {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0.8em;
        background: url('../../assets/img/dy/bottom.png') no-repeat;
        background-position: center center;
        background-size: 100% 100%;
      }
    }
</style>
<style lang="less">
  .phoneScroll {
    img,video {
      max-width: 100%;
    }
  }
</style>